/**
 * OtherServicesStrip — "También atendemos" dentro de Precios (wisest-labs/02 D-4).
 * Franja compacta, no una sección aparte: individual y pareja ya tienen sus cards
 * en Precios; acá solo online, sexología y pareja a domicilio, sin duplicar.
 */
import React from 'react';
import { track } from '@vercel/analytics/react';
import { homeServices, getServicePrice } from '../../data/services';
import './ServicesSection.css';

const clp = (n: number) => new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 }).format(n);

// Sin el nombre del servicio en el evento (restricción de salud, 01 §9.5).
const trackCta = (canal: 'agendar' | 'whatsapp') => track('cta_click', { canal, ubicacion: 'otros-servicios' });

const ServicesSection: React.FC = () => (
  <div className="svc-strip" id="servicios">
    <h3 className="svc-strip__title">También atendemos</h3>
    <ul className="svc-strip__list">
      {homeServices.map((s) => {
        const price = getServicePrice(s);
        return (
          <li key={s.id} className={`svc-item svc-item--${s.id}`}>
            <span className="svc-item__icon" aria-hidden="true"><i className={`fas ${s.icon}`}></i></span>
            <div className="svc-item__body">
              <span className="svc-item__name">{s.name}</span>
              <span className="svc-item__meta">
                {price !== null ? `${s.flatPrice ? '' : 'desde '}${clp(price)}` : 'Consultar'} · {s.duration} · {s.modality}
              </span>
            </div>
            <a
              href={s.bookable ? '/agendar' : `https://wa.me/56978009119?text=${encodeURIComponent(s.whatsappText)}`}
              className="svc-item__cta"
              {...(s.bookable ? {} : { target: '_blank', rel: 'noopener noreferrer' })}
              onClick={() => trackCta(s.bookable ? 'agendar' : 'whatsapp')}
              aria-label={`${s.bookable ? 'Agendar' : 'Consultar por WhatsApp'}: ${s.name}`}
            >
              {s.bookable ? 'Agendar' : 'Consultar'}
              <i className="fas fa-arrow-right" aria-hidden="true"></i>
            </a>
          </li>
        );
      })}
    </ul>
  </div>
);

export default ServicesSection;
